// extracted by mini-css-extract-plugin
module.exports = {"container":"InsufficientStatus_container__xiWB9","error":"InsufficientStatus_error__rBsYd"};